import styled from "styled-components";
import Colors from "../../../../Constant/Colors";
import SmartImage from "../../../../Components/SmartImage";
import { STYLES } from "../../../../Constant/Theme";

export const Container = styled.div`
  display:  flex;
  width: 75%;
  min-width: 390px;
  height: 95%;
  flex-direction: column;
  box-sizing: border-box;
  padding: 30px;
  ${STYLES.borderShadow};
  margin-top: 20px;
  margin-left: 15px;
  border-radius: 8px;
  overflow:scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  @media only screen and (max-width: 600px) {
    width: 180px;
  }
`;
